import {
  ActionIcon,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  GridCol,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useIsFirstRender, useMediaQuery } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconEdit,
  IconPlus,
  IconSearch,
  IconTransferIn,
  IconTransferOut,
  IconTrash,
  IconUserCode,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import {
  _timerDelayClick,
  keySearchRerequestManagerTransfer,
  keySearchWaRerequestTransfer,
  repositoryDelivery,
  repositoryMdm,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../_base/model/_base/SelectListItemBase";
import { _localization } from "../../config/location";
import { MessageResponse } from "../../model/MessageResponse";
import { getTblDmEmployeeSelect } from "../../service/getSelectApi";
import ModalCreateRequestManagerTransfer from "./ModalCreateRequestManagerTransfer";

export interface TransferManagerRequest {
  id: number;
  nhanVienId: number;
  cnDiId: string[];
  maCnDi: string[];
  cnDenId: string[];
  maCnDen: string[];
  attribute1: string;
  attribute2: string;
  attribute3: string;
  attribute4: string;
  attribute5: string;
  attribute6: string;
  attribute7: string;
  attribute8: string;
  attribute9: string;
  attribute10: string;
  attribute11: string;
  attribute12: string;
  attribute13: string;
  attribute14: string;
  attribute15: string;
}

const RequestManagerTransfer = () => {
  const isSmallScreen705 = useMediaQuery("(max-width: 705px)");
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });

  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TransferManagerRequest[]>([]);
  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);

  const sizeGrid = { base: 12, sm: 4, md: 3, lg: 3, xl: 2 };
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);

  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const firstRender = useIsFirstRender();

  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const _searchJson = localStorage.getItem(keySearchRerequestManagerTransfer)
    ? JSON.parse(localStorage.getItem(keySearchRerequestManagerTransfer) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const innitStateSearch = useMemo(
    () => ({
      KeySearch:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.KeySearch as string)
          : "",
      CnDiId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CnDiId as string)
          : "",
      CnDenId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CnDenId as string)
          : "",
      NhanVienId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.NhanVienId as string)
          : "",
    }),
    [firstRender, _searchJson],
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "stt",
        header: "STT",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.index === -1 ? "" : row.index + 1}
          </Text>
        ),
        size: 50,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        enableResizing: false,
      },
      {
        accessorKey: "nhanVienId",
        header: "Tên nhân viên",
        Cell: ({ row }) => {
          const e = dataEmployee.find(
            (e) => Number(e.value) === Number(row.original.nhanVienId),
          );
          return (
            <Text fw={500} size="12.5px">
              {e ? e.label : ""}
            </Text>
          );
        },
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 300,
      },
      {
        accessorKey: "cnDiId",
        header: "Chi nhánh đi được phân quyền điều chuyển",
        Cell: ({ renderedCellValue }) =>
          !renderedCellValue ? (
            <Text fw={500} size="12.5px">
              Tất cả
            </Text>
          ) : renderedCellValue &&
            Array.isArray(renderedCellValue) &&
            renderedCellValue.every((i: any) =>
              dataBranch.map((item) => String(item?.value)).includes(i),
            ) &&
            renderedCellValue.length ===
              dataBranch
                .filter((item) => item.value)
                .map((item) => String(item?.value)).length ? (
            <Text fw={500} size="12.5px">
              Tất cả
            </Text>
          ) : renderedCellValue &&
            Array.isArray(renderedCellValue) &&
            renderedCellValue.length > 0 ? (
            <Text fw={500} size="12.5px">
              {dataBranch
                .filter((i: any) => renderedCellValue.includes(String(i.value)))
                .map((i: any) => String(i.text))
                .join(", ")}
            </Text>
          ) : (
            <></>
          ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 500,
      },
      // {
      //     accessorKey: "cnDenId",
      //     header: " ID Chi nhánh đến",
      //     enableColumnActions: false,
      //     enableColumnFilter: false,
      //     enableSorting: false,
      // },
      // {
      //     accessorKey: "maCnDen",
      //     header: "Mã Chi nhánh đến",
      //     Cell: ({ row }) => {
      //         const codes = row.original.maCnDen;
      //         return <Text fw={500} size="12.5px">{Array.isArray(codes) ? codes.join(', ') : codes || ''}</Text>;
      //     },
      //     enableColumnActions: false,
      //     enableColumnFilter: false,
      //     enableSorting: false,
      // },
      {
        accessorKey: "cnDenId",
        header: "Chi nhánh đến được phân quyền điều chuyển",
        Cell: ({ renderedCellValue }) =>
          !renderedCellValue ? (
            <Text fw={500} size="12.5px">
              Tất cả
            </Text>
          ) : renderedCellValue &&
            Array.isArray(renderedCellValue) &&
            renderedCellValue.every((i: any) =>
              dataBranch.map((item) => String(item?.value)).includes(i),
            ) &&
            renderedCellValue.length ===
              dataBranch
                .filter((item) => item.value)
                .map((item) => String(item?.value)).length ? (
            <Text fw={500} size="12.5px">
              Tất cả
            </Text>
          ) : renderedCellValue &&
            Array.isArray(renderedCellValue) &&
            renderedCellValue.length > 0 ? (
            <Text fw={500} size="12.5px">
              {dataBranch
                .filter((i: any) => renderedCellValue.includes(String(i.value)))
                .map((i: any) => String(i.text))
                .join(", ")}
            </Text>
          ) : (
            <></>
          ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 500,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        size: 100,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  createData(row.original.nhanVienId);
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={async () => {
                  deleteData(row.original.nhanVienId);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataBranch, dataEmployee],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };
  const createData = (id?: string) => {
    modals.openConfirmModal({
      title: (
        <Title order={5}>
          {id ? "Chỉnh sửa quyền chuyển kho" : "Tạo mới quyền chuyển kho"}
        </Title>
      ),
      centered: true,
      size: "xl",
      children: (
        <ModalCreateRequestManagerTransfer onSuccess={fetchData} idEdit={id} />
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const deleteData = async (id: number) => {
    modals.openConfirmModal({
      title: `Xác nhận xóa quyền chuyển kho này?`,
      // centered: true,
      children: (
        <Text size="md" mt="md">
          Hành động này không thể hoàn tác. Vui lòng xác nhận bạn muốn xóa quyền
          chuyển kho này.
        </Text>
      ),
      labels: { confirm: "Xóa", cancel: "Hủy" },
      onCancel: () => console.log("Cancel"),
      onConfirm: async () => {
        try {
          setIsLoading(true);
          const response = await repositoryMdm.post<MessageResponse<any>>(
            `/api/v1/TblGrantTransferRights/delete`,
            [id],
          );
          if (response?.success) {
            NotificationExtension.Success("Xóa quyền chuyển kho thành công!");
            fetchData();
          } else {
            NotificationExtension.Fails(
              "Có lỗi xảy ra khi xóa quyền chuyển kho!",
            );
          }
        } catch (error) {
          console.error(error);
          NotificationExtension.Fails(
            "Có lỗi xảy ra khi xóa quyền chuyển kho!",
          );
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    // setIsRefetching(true);
    // setIsError(false);
    let queryParams = {
      Skip:
        firstRender && _searchJson
          ? _searchJson.Skip
          : pagination.pageIndex * pagination.pageSize,
      Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
    } as any;

    try {
      const search = form.getValues();
      queryParams = {
        ...queryParams,
        KeySearch: search.KeySearch ? search.KeySearch.toString() : "",
        CnDiId: search.CnDiId ? search.CnDiId.toString() : "",
        CnDenId: search.CnDenId ? search.CnDenId.toString() : "",
        NhanVienId: search.NhanVienId ? search.NhanVienId.toString() : "",
      };

      let url = "";
      url =
        `/api/v1/TblGrantTransferRights/get-list?` +
        Object.entries(queryParams)
          .filter(([, value]) => value !== undefined && value !== "")
          .map(
            ([key, value]) =>
              `${key}=${encodeURIComponent(value as string | number | boolean)}`,
          )
          .join("&");

      const response = await repositoryMdm.get<MessageResponse<any>>(url);
      if (response?.success) {
        setData(response.data || []);
        setRowCount(response.totalCount);
        setSelectIds([]);

        table.resetRowSelection();
      } else {
        setData([]);
        setIsError(true);
      }
    } catch (error) {
      console.error(error);
      // setData([]);
      setIsError(true);
    } finally {
      setIsLoading(false);
      // setIsRefetching(false);
      startCountdown();
      localStorage.setItem(
        keySearchWaRerequestTransfer,
        JSON.stringify(queryParams),
      );
    }
  };

  // Lấy danh sách nhân viên
  const getDataEmpSelect = async () => {
    const res = await getTblDmEmployeeSelect();
    setDataEmployee(
      res
        ?.filter(
          (item) =>
            item.value != null && item.text != null && item.value !== "-1",
        )
        ?.map((item) => ({
          value: item.value,
          label: `${item.att1} - ${item.text} `,
        })),
    );
  };

  // Lấy danh sách chi nhánh
  const fetchBranchCode = async () => {
    try {
      const response = await repositoryDelivery.get<MessageResponse<any[]>>(
        `/api/v1/TblDmMasterOrg/get-select`,
      );
      if (response && response.success) {
        const data = response.data;
        setDataBranch(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useEffect(() => {
    Promise.all([fetchBranchCode(), getDataEmpSelect()]);
  }, []);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    // enableRowSelection: true,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["stt", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onSortingChange: setSorting,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontSize: "12.5px",
        padding: "4px 12px",
        fontWeight: 500,
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: !isSmallScreen705 ? true : false,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: !isSmallScreen705 ? "pages" : "default",
    enableColumnPinning: !isSmallScreen705 ? true : false,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <div>
            <_breadcrumb></_breadcrumb>
          </div>
          <div>
            <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              w={"100%"}
              onClick={() => {
                createData();
              }}
            >
              Tạo mới (F11)
            </Button>
          </div>
        </Flex>

        <Grid mt={10}>
          <GridCol span={sizeGrid}>
            <TextInput
              key={form.key("KeySearch")}
              placeholder="Từ khoá"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("KeySearch")}
            />
          </GridCol>

          <Grid.Col span={sizeGrid}>
            <Select
              key={dataBranch.length}
              placeholder="Chi nhánh đi"
              searchable
              clearable
              data={dataBranch
                .filter((ele) => ele.att1 && ele.text)
                .map((ele) => ({
                  label: ele.att1 + " - " + ele.text,
                  value: ele.value,
                }))}
              leftSection={<IconTransferOut color="#15aabf" />}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              {...form.getInputProps("CnDiId")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={dataBranch.length}
              placeholder="Chi nhánh đến"
              searchable
              clearable
              data={dataBranch
                .filter((ele) => ele.att1 && ele.text)
                .map((ele) => ({
                  label: ele.att1 + " - " + ele.text,
                  value: ele.value,
                }))}
              leftSection={<IconTransferIn color="#15aabf" />}
              {...form.getInputProps("CnDenId")}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              key={dataEmployee.length}
              placeholder={"Chọn nhân viên"}
              searchable
              clearable
              leftSection={<IconUserCode color="#15aabf" />}
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              data={dataEmployee.map((ele) => ({
                label: ele.label,
                value: ele.value,
              }))}
              nothingFoundMessage={"Loading..."}
              {...form.getInputProps("NhanVienId")}
              onClick={() => {
                if (dataEmployee.length === 0) {
                  getDataEmpSelect();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              loading={isLoading}
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default RequestManagerTransfer;
